// paymentMethodSchema.js
import { z } from 'zod';

// Word IDs coming from the UI
export const PaymentId = z.enum([
  'EBank',
  'Insurance',
  'Juridical',
  'OnSite',
  'PSDF',
  'Stebby'
]);

// Optional: mapping to backend numeric codes if/when you need it
export const PAYMENT_CODE = {
  EBank: 1,
  Insurance: 2,
  Juridical: 3,
  OnSite: 4,
  Stebby: 5,
};

export function toPaymentCode(id) {
  return PAYMENT_CODE[id] ?? 0; // 0 = Undefined (if you use it)
}

export const paymentMethodSchema = z
  .object({
    paymentId: z.string().min(1, 'Pasirinkite mokėjimo būdą'), // now matches your RadioGroup values
    insurance: z.string().optional(),
    company: z.string().optional(),
    agreePrivacy: z.boolean().refine((v) => v === true, {
      message: 'Privaloma sutikti su duomenų tvarkymo taisyklėmis',
    }),
    agreePortal: z.boolean().refine((v) => v === true, {
      message: 'Privaloma sutikti su portalo naudojimosi taisyklėmis',
    }),
  })
  .superRefine((data, ctx) => {
    // Require insurance when Insurance is selected
    if (
      data.paymentId === 'Insurance' &&
      (!data.insurance || data.insurance.trim() === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Pasirinkite draudiką',
        path: ['insurance'],
      });
    }
    // Require company when Juridical is selected
    if (
      data.paymentId === 'Juridical' &&
      (!data.company || data.company.trim() === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Įveskite juridinio mokėtojo pavadinimą arba kodą',
        path: ['company'],
      });
    }
  });

export function getDefaultValues(canUseEBank) {
  return {
    paymentId: canUseEBank ? '' : 'EBank', // default matches UI
    insurance: '',
    company: '',
    agreePrivacy: false,
    agreePortal: false,
  };
}
